import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import DPServices from "@dp/services";
import { action, computed, makeObservable, observable, reaction, runInAction } from "mobx";
import moment from "moment";
import { CartModel, ContactInfoModel, LocationModel } from ".";
import Errors, { ERROR_STRINGS } from "./Errors";
import Base from "./Base";
import DineInOrderModel from "./models/DineInOrderModel";
import DineInConfirmationModel from "./models/DineInConfirmationModel";
import { formatPhoneNumber, getLocalISODateString, handle, PlatformType } from "@dp/common";
import i18next from "i18next";
import { FETCH_TIME_TYPE } from "./MenuList";
var DineInOrder = (_class = /*#__PURE__*/function (_Base) {
  _inherits(DineInOrder, _Base);

  var _super = _createSuper(DineInOrder);

  function DineInOrder(rootStore) {
    var _this$rootStore10, _this$rootStore10$use;

    var _this;

    _classCallCheck(this, DineInOrder);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _defineProperty(_assertThisInitialized(_this), "dineInOrderModel", null);

    _defineProperty(_assertThisInitialized(_this), "cartModel", null);

    _defineProperty(_assertThisInitialized(_this), "dineInConfirmationModel", null);

    _defineProperty(_assertThisInitialized(_this), "appMessages", null);

    _defineProperty(_assertThisInitialized(_this), "contactInfoModel", null);

    _defineProperty(_assertThisInitialized(_this), "locationModel", null);

    _defineProperty(_assertThisInitialized(_this), "analyticsModel", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "cartOrder", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_restuarantDetails", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_sessionDetails", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_appAttributes", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "checkoutAttributes", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_submitCount", _descriptor6, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "initiateDineInOrder", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(restNum, visitId, source, kind) {
        var _assertThisInitialize, _assertThisInitialize2, _assertThisInitialize3, _assertThisInitialize4, _assertThisInitialize5, _this$rootStore, _this$rootStore$commo, _this$rootStore2, _this$rootStore2$user, orderId, JWT_TOKEN, initDineInOrderResponse, _initDineInOrderRespo, _assertThisInitialize6, _assertThisInitialize7, _assertThisInitialize8, _assertThisInitialize9, _initDineInOrderRespo2, _this$rootStore3, _this$rootStore3$menu, _this$rootStore4, _this$rootStore4$menu, _this$rootStore4$menu2, _this$rootStore4$menu3, _this$rootStore5, _this$rootStore5$menu, _this$rootStore6, _this$rootStore6$user, startTime, errorMessage;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                /**
                 * NOTE: This won't happen in actual [Calling initiateDineInOrder when already in OA flow]
                 * Prevent sending ToGO order to initiateDineInOrder as it won't be using same id it generates new one
                 */

                orderId = ((_assertThisInitialize = _assertThisInitialized(_this)) === null || _assertThisInitialize === void 0 ? void 0 : (_assertThisInitialize2 = _assertThisInitialize.rootStore) === null || _assertThisInitialize2 === void 0 ? void 0 : (_assertThisInitialize3 = _assertThisInitialize2.user) === null || _assertThisInitialize3 === void 0 ? void 0 : (_assertThisInitialize4 = _assertThisInitialize3.sessionDetails) === null || _assertThisInitialize4 === void 0 ? void 0 : (_assertThisInitialize5 = _assertThisInitialize4.orderContext) === null || _assertThisInitialize5 === void 0 ? void 0 : _assertThisInitialize5.orderTypeValue) === 5 ? (_this$rootStore = _this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$commo = _this$rootStore.common) === null || _this$rootStore$commo === void 0 ? void 0 : _this$rootStore$commo.orderID : null;
                _context.next = 4;
                return (_this$rootStore2 = _this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$user = _this$rootStore2.user) === null || _this$rootStore2$user === void 0 ? void 0 : _this$rootStore2$user.getTokenSilentIfLoggedIn();

              case 4:
                JWT_TOKEN = _context.sent;
                _context.next = 7;
                return DPServices.DineInOrder.initiateDineInOrder(orderId, restNum, visitId, source, kind, JWT_TOKEN);

              case 7:
                initDineInOrderResponse = _context.sent;

                if (!(initDineInOrderResponse.statusCode === 200)) {
                  _context.next = 19;
                  break;
                }

                _this.rootStore.common.orderID = initDineInOrderResponse === null || initDineInOrderResponse === void 0 ? void 0 : (_initDineInOrderRespo = initDineInOrderResponse.order) === null || _initDineInOrderRespo === void 0 ? void 0 : _initDineInOrderRespo.orderId;
                (_assertThisInitialize6 = _assertThisInitialized(_this)) === null || _assertThisInitialize6 === void 0 ? void 0 : (_assertThisInitialize7 = _assertThisInitialize6.rootStore) === null || _assertThisInitialize7 === void 0 ? void 0 : (_assertThisInitialize8 = _assertThisInitialize7.menuList) === null || _assertThisInitialize8 === void 0 ? void 0 : (_assertThisInitialize9 = _assertThisInitialize8.orderSettingsModel) === null || _assertThisInitialize9 === void 0 ? void 0 : _assertThisInitialize9.setOrderTypeValue(initDineInOrderResponse === null || initDineInOrderResponse === void 0 ? void 0 : (_initDineInOrderRespo2 = initDineInOrderResponse.order) === null || _initDineInOrderRespo2 === void 0 ? void 0 : _initDineInOrderRespo2.orderType); // getting slots for current restaurant

                _context.next = 13;
                return (_this$rootStore3 = _this.rootStore) === null || _this$rootStore3 === void 0 ? void 0 : (_this$rootStore3$menu = _this$rootStore3.menuList) === null || _this$rootStore3$menu === void 0 ? void 0 : _this$rootStore3$menu.fetchTimes(null, FETCH_TIME_TYPE.DINE_IN_FLOW, null, restNum);

              case 13:
                // getting first slot
                startTime = (_this$rootStore4 = _this.rootStore) === null || _this$rootStore4 === void 0 ? void 0 : (_this$rootStore4$menu = _this$rootStore4.menuList) === null || _this$rootStore4$menu === void 0 ? void 0 : (_this$rootStore4$menu2 = _this$rootStore4$menu.timeModel) === null || _this$rootStore4$menu2 === void 0 ? void 0 : (_this$rootStore4$menu3 = _this$rootStore4$menu2.availableSlots[0]) === null || _this$rootStore4$menu3 === void 0 ? void 0 : _this$rootStore4$menu3.startTimeInMs; // set Restaurant and first time slot

                _context.next = 16;
                return (_this$rootStore5 = _this.rootStore) === null || _this$rootStore5 === void 0 ? void 0 : (_this$rootStore5$menu = _this$rootStore5.menuList) === null || _this$rootStore5$menu === void 0 ? void 0 : _this$rootStore5$menu.setOrderPickupTimeAndLocation(moment(startTime).toDate(), restNum, "orderAhead");

              case 16:
                _context.next = 18;
                return (_this$rootStore6 = _this.rootStore) === null || _this$rootStore6 === void 0 ? void 0 : (_this$rootStore6$user = _this$rootStore6.user) === null || _this$rootStore6$user === void 0 ? void 0 : _this$rootStore6$user.updateSession();

              case 18:
                return _context.abrupt("return");

              case 19:
                _context.next = 27;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context["catch"](0);
                _context.next = 25;
                return _this.parseError(_context.t0);

              case 25:
                errorMessage = _context.sent;

                _this.appMessages.showError(errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.title, errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.message, null, errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.options);

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 21]]);
      }));

      return function (_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "dineInToPickupSwitch", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$rootStore7, _this$rootStore7$menu, _this$dineInOrderMode, _this$rootStore8, _this$rootStore9, _this$rootStore9$plat;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (_this$rootStore7 = _this.rootStore) === null || _this$rootStore7 === void 0 ? void 0 : (_this$rootStore7$menu = _this$rootStore7.menuList) === null || _this$rootStore7$menu === void 0 ? void 0 : _this$rootStore7$menu.clearCart();

            case 3:
              // clear cart creates new orderid so need clear old one.
              _this.rootStore.common.orderID = null;
              (_this$dineInOrderMode = _this.dineInOrderModel) === null || _this$dineInOrderMode === void 0 ? void 0 : _this$dineInOrderMode.setSwitchFromDineInMessageVisibility(false);
              _context2.next = 7;
              return (_this$rootStore8 = _this.rootStore) === null || _this$rootStore8 === void 0 ? void 0 : _this$rootStore8.user.updateSession();

            case 7:
              /**
               * cannot directly refresh page as if URL still has param it will init
               * Order Ahead again. redirectToURL() will perform navigation
               * with page refresh
               */
              (_this$rootStore9 = _this.rootStore) === null || _this$rootStore9 === void 0 ? void 0 : (_this$rootStore9$plat = _this$rootStore9.platformUtil) === null || _this$rootStore9$plat === void 0 ? void 0 : _this$rootStore9$plat.redirectToURL("/menu");
              _context2.next = 14;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);

              _this.dineInOrderModel.setSwitchFromDineInMessageVisibility(false);

              _this.appMessages.showError("Something went wrong", "Dinein to pickup switch failed");

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 10]]);
    })));

    _this.rootStore = rootStore;
    _this.dineInOrderModel = new DineInOrderModel(_this.rootStore.platformUtil);
    _this.dineInConfirmationModel = new DineInConfirmationModel(_this.rootStore.platformUtil);
    _this.appMessages = rootStore.appMessages;
    _this.cartModel = new CartModel(_this.rootStore.platformUtil);
    _this.contactInfoModel = new ContactInfoModel(_this.rootStore.platformUtil);
    _this.locationModel = new LocationModel();
    _this.analyticsModel = (_this$rootStore10 = _this.rootStore) === null || _this$rootStore10 === void 0 ? void 0 : (_this$rootStore10$use = _this$rootStore10.user) === null || _this$rootStore10$use === void 0 ? void 0 : _this$rootStore10$use.analyticsModel;
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DineInOrder, [{
    key: "_processSessionDetails",
    value: function _processSessionDetails(session) {
      var _this2 = this;

      runInAction(function () {
        var _session$orderContext;

        _this2._sessionDetails = session;

        _this2.dineInOrderModel.setSessionDetailsData(session);

        _this2.dineInConfirmationModel.setSessionDetailsData(session);

        _this2.locationModel.locationDateTime.actualPickupDateTime = (_session$orderContext = session.orderContext) === null || _session$orderContext === void 0 ? void 0 : _session$orderContext.actualPickupDateTime;
        _this2.locationModel.sessionDetails = session;
      });
    }
  }, {
    key: "_processAppAttributes",
    value: function () {
      var _processAppAttributes2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(appAttributes) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this._appAttributes = appAttributes;
                this.dineInOrderModel.setAppAttributesData(appAttributes);
                this.dineInConfirmationModel.setAppAttributesData(appAttributes);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _processAppAttributes(_x5) {
        return _processAppAttributes2.apply(this, arguments);
      }

      return _processAppAttributes;
    }()
  }, {
    key: "_processUserProfile",
    value: function _processUserProfile(isLoggedIn, userProfile) {
      //for pay at restaurant
      this.contactInfoModel.phoneNumberVisible = true;

      if (isLoggedIn && userProfile) {
        var _userProfile$defaultP;

        this.contactInfoModel.fName = userProfile.firstName;
        this.contactInfoModel.lName = userProfile.lastName;
        this.contactInfoModel.emailId = userProfile.login;
        var defaultPhoneNumber = (_userProfile$defaultP = userProfile.defaultPhone) === null || _userProfile$defaultP === void 0 ? void 0 : _userProfile$defaultP.phoneNumber;
        this.contactInfoModel.phoneNumber = formatPhoneNumber(defaultPhoneNumber);
      }
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return handle(this.rootStore.platformUtil.hydrateUsingSessionStorage(["ORDER_LEVEL_INSTRUCTIONS"].join("-"), this.dineInOrderModel));

              case 2:
                this._processSessionDetails(this.rootStore.user.sessionDetails);

                this._processAppAttributes(this.rootStore.common.appAttributes);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", Promise.resolve());

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", Promise.resolve());

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "logoutReset",
    value: function () {
      var _logoutReset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", Promise.resolve());

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function logoutReset() {
        return _logoutReset.apply(this, arguments);
      }

      return logoutReset;
    }()
  }, {
    key: "setupReactions",
    value: function setupReactions() {
      var _this3 = this; //app-init


      reaction(function () {
        return {
          appAttributes: _this3.rootStore.common.appAttributes
        };
      }, function (data) {
        _this3._processAppAttributes(data.appAttributes);
      }); //session-details

      reaction(function () {
        return {
          sessionDetails: _this3.rootStore.user.sessionDetails
        };
      }, /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(data) {
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _this3._processSessionDetails(data.sessionDetails);

                case 1:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        return function (_x6) {
          return _ref3.apply(this, arguments);
        };
      }()); // restuarant details

      reaction(function () {
        var _this3$rootStore, _this3$rootStore$rest;

        return {
          detail: (_this3$rootStore = _this3.rootStore) === null || _this3$rootStore === void 0 ? void 0 : (_this3$rootStore$rest = _this3$rootStore.restaurant) === null || _this3$rootStore$rest === void 0 ? void 0 : _this3$rootStore$rest.detail
        };
      }, /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(data) {
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _this3._restuarantDetails = data === null || data === void 0 ? void 0 : data.detail;

                  _this3.dineInOrderModel.setRestaurantDetailData(data === null || data === void 0 ? void 0 : data.detail);

                  _this3.dineInConfirmationModel.setRestaurantDetailData(data === null || data === void 0 ? void 0 : data.detail);

                case 3:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        }));

        return function (_x7) {
          return _ref4.apply(this, arguments);
        };
      }()); //user-profile

      reaction(function () {
        return {
          userProfile: _this3.rootStore.user.userProfile,
          isLoggedIn: _this3.rootStore.user.isLoggedIn
        };
      }, function (data) {
        if (data.isLoggedIn) {
          _this3._processUserProfile(data.isLoggedIn, data.userProfile);
        }
      });
    }
  }, {
    key: "parseError",
    value: function () {
      var _parseError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(e) {
        var _e$errors,
            _this4 = this;

        var error;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                error = e === null || e === void 0 ? void 0 : (_e$errors = e.errors) === null || _e$errors === void 0 ? void 0 : _e$errors[0];

                if (!((error === null || error === void 0 ? void 0 : error.code) === "ORDER_AHEAD_NOT_AVAILABLE")) {
                  _context10.next = 5;
                  break;
                }

                return _context10.abrupt("return", {
                  title: "Order Ahead Not Available",
                  message: "Pre ordering for dine-in is not available at this location",
                  additionalMessages: null,
                  options: {
                    undismissible: true,
                    okBtnText: "Ok",
                    okBtnOnClick: function okBtnOnClick() {
                      var _this4$rootStore;

                      (_this4$rootStore = _this4.rootStore) === null || _this4$rootStore === void 0 ? void 0 : _this4$rootStore.platformUtil.navigateToRoute("/home");
                    }
                  }
                });

              case 5:
                if (!((error === null || error === void 0 ? void 0 : error.code) === "CRT473")) {
                  _context10.next = 7;
                  break;
                }

                return _context10.abrupt("return", {
                  title: i18next.t("error.dipo.init.failed.rest_closed.title", {
                    defaultValue: " "
                  }),
                  message: i18next.t("error.dipo.init.failed.rest_closed.message", {
                    defaultValue: "Restaurant is closed."
                  }),
                  additionalMessages: null,
                  options: {
                    undismissible: true,
                    okBtnText: "Ok",
                    okBtnOnClick: function okBtnOnClick() {
                      _this4.dineInToPickupSwitch();
                    }
                  }
                });

              case 7:
                return _context10.abrupt("return", {
                  title: i18next.t("error.dipo.init.failed.title", {
                    defaultValue: "Something went wrong"
                  }),
                  message: i18next.t("error.dipo.init.failed.message", {
                    defaultValue: "Please click the button below to reload the page."
                  }),
                  additionalMessages: null,
                  options: {
                    undismissible: true,
                    okBtnText: "Ok",
                    okBtnOnClick: function okBtnOnClick() {
                      var _this4$rootStore2, _this4$rootStore2$pla;

                      _this4 === null || _this4 === void 0 ? void 0 : (_this4$rootStore2 = _this4.rootStore) === null || _this4$rootStore2 === void 0 ? void 0 : (_this4$rootStore2$pla = _this4$rootStore2.platformUtil) === null || _this4$rootStore2$pla === void 0 ? void 0 : _this4$rootStore2$pla.navigateToRoute("/home");
                    }
                  }
                });

              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function parseError(_x8) {
        return _parseError.apply(this, arguments);
      }

      return parseError;
    }()
  }, {
    key: "redirectToMenuPage",
    value: function () {
      var _redirectToMenuPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                this.rootStore.refreshInProgress = true;
                this.rootStore.platformUtil.redirectToURL("/menu");

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function redirectToMenuPage() {
        return _redirectToMenuPage.apply(this, arguments);
      }

      return redirectToMenuPage;
    }()
  }, {
    key: "getLastOrderData",
    value: function () {
      var _getLastOrderData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(orderID) {
        var jwtToken, order, _order$order;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (orderID) {
                  _context12.next = 3;
                  break;
                }

                this.redirectToMenuPage();
                return _context12.abrupt("return");

              case 3:
                _context12.next = 5;
                return this.rootStore.user.getTokenSilentIfLoggedIn();

              case 5:
                jwtToken = _context12.sent;
                _context12.next = 8;
                return DPServices.Confirmation.getLastOrder(orderID, jwtToken);

              case 8:
                order = _context12.sent;

                if (!(order && Object.keys(order).length > 0)) {
                  _context12.next = 13;
                  break;
                }

                this.dineInConfirmationModel.setLastOrderData(order);
                this.setCartItems(order === null || order === void 0 ? void 0 : (_order$order = order.order) === null || _order$order === void 0 ? void 0 : _order$order.commerceItems);
                return _context12.abrupt("return");

              case 13:
                this.redirectToMenuPage();

              case 14:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getLastOrderData(_x9) {
        return _getLastOrderData.apply(this, arguments);
      }

      return getLastOrderData;
    }()
  }, {
    key: "setCartItems",
    value: function () {
      var _setCartItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(commerceItems) {
        var cartItems;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                cartItems = this.cartModel.getCartItemsFromCommerceItems(commerceItems);
                this.dineInConfirmationModel.setCartItems(cartItems);

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function setCartItems(_x10) {
        return _setCartItems.apply(this, arguments);
      }

      return setCartItems;
    }()
  }, {
    key: "initDineInCheckout",
    value: function () {
      var _initDineInCheckout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var _this$rootStore11,
            _this$rootStore11$use,
            _this$rootStore12,
            _this$rootStore12$use,
            _this5 = this,
            _this$rootStore13,
            _this$rootStore13$com;

        var jwtToken, _yield$handle, _yield$handle2, err, checkoutAttributes, _yield$handle3, _yield$handle4, cartDetailsErr, cartDetailsResponse, errorUI;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                this.dineInOrderModel.isCheckoutPageLoading = true;
                _context15.next = 3;
                return handle(this.rootStore.platformUtil.hydrateUsingLocalStorage("CHECKOUT_CONTACT_INFO", this.contactInfoModel));

              case 3:
                this._processUserProfile((_this$rootStore11 = this.rootStore) === null || _this$rootStore11 === void 0 ? void 0 : (_this$rootStore11$use = _this$rootStore11.user) === null || _this$rootStore11$use === void 0 ? void 0 : _this$rootStore11$use.isLoggedIn, (_this$rootStore12 = this.rootStore) === null || _this$rootStore12 === void 0 ? void 0 : (_this$rootStore12$use = _this$rootStore12.user) === null || _this$rootStore12$use === void 0 ? void 0 : _this$rootStore12$use.userProfile);

                _context15.next = 6;
                return this.rootStore.user.getTokenSilentIfLoggedIn();

              case 6:
                jwtToken = _context15.sent;
                _context15.next = 9;
                return handle(DPServices.Common.getCheckoutInitAttributes({
                  jwtToken: jwtToken
                }));

              case 9:
                _yield$handle = _context15.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                err = _yield$handle2[0];
                checkoutAttributes = _yield$handle2[1];

                if (err) {
                  this.appMessages.showError("Checkout", "Invalid State. Please Go Back.", null, {
                    undismissible: true,
                    okBtnText: "Go Back",
                    okBtnOnClick: function okBtnOnClick() {
                      _this5.redirectToEmptyCartPage();
                    }
                  });
                } else {
                  if (checkoutAttributes) {
                    runInAction(function () {
                      var _checkoutAttributes$o;

                      if (!(checkoutAttributes !== null && checkoutAttributes !== void 0 && (_checkoutAttributes$o = checkoutAttributes.orderContext) !== null && _checkoutAttributes$o !== void 0 && _checkoutAttributes$o.checkCreated)) {
                        _this5.redirectToEmptyCartPage();
                      } else {
                        _this5.checkoutAttributes = checkoutAttributes;
                      }
                    });
                  }
                } // getCartDetails


                _context15.next = 16;
                return handle(DPServices.Cart.getCartDetails({
                  orderId: (_this$rootStore13 = this.rootStore) === null || _this$rootStore13 === void 0 ? void 0 : (_this$rootStore13$com = _this$rootStore13.common) === null || _this$rootStore13$com === void 0 ? void 0 : _this$rootStore13$com.orderID
                }, jwtToken));

              case 16:
                _yield$handle3 = _context15.sent;
                _yield$handle4 = _slicedToArray(_yield$handle3, 2);
                cartDetailsErr = _yield$handle4[0];
                cartDetailsResponse = _yield$handle4[1];

                if (cartDetailsErr) {
                  errorUI = DPServices.Common.handleUIErrorAndOverride(cartDetailsErr, {
                    title: ERROR_STRINGS.CART_GET_ORDER_DETAILS,
                    message: Errors.CART_GET_ORDER_DETAILS_FAILED.message
                  });
                  this.appMessages.showError(errorUI.title, errorUI.message, null, {
                    undismissible: true,
                    okBtnText: "Go Back",
                    okBtnOnClick: function okBtnOnClick() {
                      _this5.redirectToEmptyCartPage();
                    }
                  });
                } else {
                  runInAction( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
                    var _this5$dineInConfirma;

                    var order;
                    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                      while (1) {
                        switch (_context14.prev = _context14.next) {
                          case 0:
                            order = cartDetailsResponse === null || cartDetailsResponse === void 0 ? void 0 : cartDetailsResponse.order;
                            (_this5$dineInConfirma = _this5.dineInConfirmationModel) === null || _this5$dineInConfirma === void 0 ? void 0 : _this5$dineInConfirma.setLastOrderData(cartDetailsResponse);

                            if (order) {
                              _this5._processCartResponse(order);
                            }

                          case 3:
                          case "end":
                            return _context14.stop();
                        }
                      }
                    }, _callee14);
                  })));
                }

                this.dineInOrderModel.isCheckoutPageLoading = false;

              case 22:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function initDineInCheckout() {
        return _initDineInCheckout.apply(this, arguments);
      }

      return initDineInCheckout;
    }()
  }, {
    key: "redirectToEmptyCartPage",
    value: function redirectToEmptyCartPage() {
      if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB) {
        var _this$checkoutAttribu;

        if ((_this$checkoutAttribu = this.checkoutAttributes) !== null && _this$checkoutAttribu !== void 0 && _this$checkoutAttribu.cartEmptyURL) {
          this.rootStore.refreshInProgress = true;
          this.rootStore.platformUtil.redirectToURL(this.checkoutAttributes.cartEmptyURL);
        } else {
          this.rootStore.refreshInProgress = true;
          this.rootStore.platformUtil.redirectToURL("/order-online?cartEmpty=true");
        }
      } else {
        this.rootStore.reloadApp();
      }
    }
  }, {
    key: "_processCartResponse",
    value: function () {
      var _processCartResponse2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(order) {
        var _this$_sessionDetails, _this$_sessionDetails2, restaurantNumber, _restaurantDetail$con, _restaurantDetail$con2, _address$coordinates, _address$coordinates2, restaurantDetail, restaurantName, restPhoneNumber, address, phoneNumber, latitude, longitude, zipValue, location;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                if (!order) {
                  _context16.next = 17;
                  break;
                }

                this.cartOrder = order;
                restaurantNumber = this === null || this === void 0 ? void 0 : (_this$_sessionDetails = this._sessionDetails) === null || _this$_sessionDetails === void 0 ? void 0 : (_this$_sessionDetails2 = _this$_sessionDetails.restaurantDetails) === null || _this$_sessionDetails2 === void 0 ? void 0 : _this$_sessionDetails2.restaurantNumber;

                if (!restaurantNumber) {
                  _context16.next = 17;
                  break;
                }

                _context16.next = 6;
                return DPServices.Restaurant.getRestaurantDetailsByNumber(restaurantNumber);

              case 6:
                restaurantDetail = _context16.sent;
                restaurantName = restaurantDetail === null || restaurantDetail === void 0 ? void 0 : restaurantDetail.restaurantName;
                restPhoneNumber = restaurantDetail === null || restaurantDetail === void 0 ? void 0 : (_restaurantDetail$con = restaurantDetail.contactDetail) === null || _restaurantDetail$con === void 0 ? void 0 : _restaurantDetail$con.phoneDetail;
                address = restaurantDetail === null || restaurantDetail === void 0 ? void 0 : (_restaurantDetail$con2 = restaurantDetail.contactDetail) === null || _restaurantDetail$con2 === void 0 ? void 0 : _restaurantDetail$con2.address;
                phoneNumber = restPhoneNumber === null || restPhoneNumber === void 0 ? void 0 : restPhoneNumber[0]; //not safe

                latitude = address === null || address === void 0 ? void 0 : (_address$coordinates = address.coordinates) === null || _address$coordinates === void 0 ? void 0 : _address$coordinates.latitude;
                longitude = address === null || address === void 0 ? void 0 : (_address$coordinates2 = address.coordinates) === null || _address$coordinates2 === void 0 ? void 0 : _address$coordinates2.longitude;
                zipValue = address.zipCode ? address.zipCode : null;
                location = {
                  restaurantName: restaurantName,
                  address1: address === null || address === void 0 ? void 0 : address.street1,
                  address2: address === null || address === void 0 ? void 0 : address.street2,
                  city: address.city,
                  state: address === null || address === void 0 ? void 0 : address.stateCode,
                  zip: zipValue === null || zipValue === void 0 ? void 0 : zipValue.toString(),
                  phoneNumber: formatPhoneNumber(phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.phoneNumber),
                  lat: (latitude === null || latitude === void 0 ? void 0 : latitude.toString()) || null,
                  lng: (longitude === null || longitude === void 0 ? void 0 : longitude.toString()) || null
                };
                this.locationModel.location = location;

                if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP) {
                  this.dineInOrderModel.setRestaurantDetailData(restaurantDetail);
                  this.dineInConfirmationModel.setRestaurantDetailData(restaurantDetail);
                }

              case 17:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function _processCartResponse(_x11) {
        return _processCartResponse2.apply(this, arguments);
      }

      return _processCartResponse;
    }()
  }, {
    key: "submitOrder",
    value: function () {
      var _submitOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var _this6 = this;

        var _this$contactInfoMode, _this$dineInOrderMode2, _this$_appAttributes, _this$_appAttributes$, _this$contactInfoMode2, _this$contactInfoMode3, _this$contactInfoMode4, _this$contactInfoMode5, _this$dineInOrderMode3, _this$contactInfoMode6, _this$rootStore14, _this$rootStore14$use, emailSignupSource, submitOrderRequest, JWT_TOKEN, response, errorMessage;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;

                if ((_this$contactInfoMode = this.contactInfoModel) !== null && _this$contactInfoMode !== void 0 && _this$contactInfoMode.isContactInfoValid) {
                  _context17.next = 4;
                  break;
                }

                this.appMessages.showError("Missing Details", "Please enter all highlighted fields.", null, {
                  okBtnText: "OK",
                  okBtnOnClick: function okBtnOnClick() {
                    var _this6$contactInfoMod;

                    _this6._submitCount = _this6.submitCount + 1;
                    var componentRef = (_this6$contactInfoMod = _this6.contactInfoModel) === null || _this6$contactInfoMod === void 0 ? void 0 : _this6$contactInfoMod.componentRef;
                    setTimeout(function () {
                      var _componentRef$current;

                      componentRef === null || componentRef === void 0 ? void 0 : (_componentRef$current = componentRef.current) === null || _componentRef$current === void 0 ? void 0 : _componentRef$current.scrollIntoView({
                        behavior: "smooth"
                      });
                    }, 150);
                  }
                });
                return _context17.abrupt("return");

              case 4:
                this.dineInOrderModel.isOrderSubmitting = true;
                emailSignupSource = (_this$dineInOrderMode2 = this.dineInOrderModel) !== null && _this$dineInOrderMode2 !== void 0 && _this$dineInOrderMode2.splOffer ? (_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : (_this$_appAttributes$ = _this$_appAttributes.configs) === null || _this$_appAttributes$ === void 0 ? void 0 : _this$_appAttributes$.dineinorder_crm_signup_source : null;
                submitOrderRequest = {
                  orderId: this.rootStore.common.orderID,
                  carType: null,
                  carColor: null,
                  legalDrinkingAgeConfirmation: "no",
                  paymentAlreadyProcessed: false,
                  emailId: (_this$contactInfoMode2 = this.contactInfoModel) === null || _this$contactInfoMode2 === void 0 ? void 0 : _this$contactInfoMode2.emailId,
                  instructions: this.dineInOrderModel.specialInstructions,
                  firstName: (_this$contactInfoMode3 = this.contactInfoModel) === null || _this$contactInfoMode3 === void 0 ? void 0 : _this$contactInfoMode3.fName,
                  lastName: (_this$contactInfoMode4 = this.contactInfoModel) === null || _this$contactInfoMode4 === void 0 ? void 0 : _this$contactInfoMode4.lName,
                  phoneNumber: (_this$contactInfoMode5 = this.contactInfoModel) === null || _this$contactInfoMode5 === void 0 ? void 0 : _this$contactInfoMode5.phoneNumber,
                  phoneType: "Primary",
                  totalBreadCount: null,
                  brandOptin: (_this$dineInOrderMode3 = this.dineInOrderModel) === null || _this$dineInOrderMode3 === void 0 ? void 0 : _this$dineInOrderMode3.splOffer,
                  emailSignupSource: emailSignupSource,
                  // dineinorder_crm_signup_source
                  complaint: "",
                  confirmLocation: false,
                  carService: false,
                  confirmEmailId: (_this$contactInfoMode6 = this.contactInfoModel) === null || _this$contactInfoMode6 === void 0 ? void 0 : _this$contactInfoMode6.emailId,
                  requestedPickupDate: this._sessionDetails.orderContext.actualPickupDate,
                  requestedPickupTime: this._sessionDetails.orderContext.actualPickupTime,
                  utensilsBean: {
                    noOfGuests: null,
                    heatingKitIncluded: false,
                    silverwareQty: 0,
                    plateQty: null,
                    bowlsQty: null,
                    butterIncluded: false,
                    cupQty: null,
                    iceIncluded: false,
                    silverwareIncluded: false,
                    breadIncluded: null,
                    condimentsList: null,
                    platesIncluded: false,
                    bowlsIncluded: false,
                    cupsIncluded: false
                  },
                  paymentCollection: [{
                    inStorePayment: {
                      amount: this.cartOrder.priceInfo.total
                    }
                  }],
                  clientIp: "",
                  correlationId: "",
                  customerLocalDate: getLocalISODateString(moment().toDate())
                };
                _context17.next = 9;
                return (_this$rootStore14 = this.rootStore) === null || _this$rootStore14 === void 0 ? void 0 : (_this$rootStore14$use = _this$rootStore14.user) === null || _this$rootStore14$use === void 0 ? void 0 : _this$rootStore14$use.getTokenSilentIfLoggedIn();

              case 9:
                JWT_TOKEN = _context17.sent;
                _context17.next = 12;
                return DPServices.Cart.submitDineInOrder(submitOrderRequest, JWT_TOKEN);

              case 12:
                response = _context17.sent;
                this.dineInOrderModel.isOrderSubmitting = false;

                if (!(this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP)) {
                  _context17.next = 17;
                  break;
                }

                _context17.next = 17;
                return this.rootStore.user.updateSession();

              case 17:
                this.redirectToConfirmationPage(response === null || response === void 0 ? void 0 : response.orderId);
                _context17.next = 27;
                break;

              case 20:
                _context17.prev = 20;
                _context17.t0 = _context17["catch"](0);
                this.dineInOrderModel.isOrderSubmitting = false;
                _context17.next = 25;
                return this.parseSubmitError(_context17.t0);

              case 25:
                errorMessage = _context17.sent;
                this.appMessages.showError(errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.title, errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.message);

              case 27:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[0, 20]]);
      }));

      function submitOrder() {
        return _submitOrder.apply(this, arguments);
      }

      return submitOrder;
    }()
  }, {
    key: "parseSubmitError",
    value: function () {
      var _parseSubmitError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(e) {
        var _e$errors2;

        var error;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                error = e === null || e === void 0 ? void 0 : (_e$errors2 = e.errors) === null || _e$errors2 === void 0 ? void 0 : _e$errors2[0];

                if (!(error === undefined)) {
                  _context18.next = 3;
                  break;
                }

                return _context18.abrupt("return", {
                  title: "Order Submit Failed",
                  message: "Try Again"
                });

              case 3:
                return _context18.abrupt("return", {
                  title: "Order Submit Failed",
                  message: error === null || error === void 0 ? void 0 : error.message
                });

              case 4:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      function parseSubmitError(_x12) {
        return _parseSubmitError.apply(this, arguments);
      }

      return parseSubmitError;
    }()
  }, {
    key: "redirectToConfirmationPage",
    value: function redirectToConfirmationPage(orderId) {
      var _this7 = this;

      this.rootStore.refreshInProgress = true;
      this.rootStore.platformUtil.clearSessionStorage()["finally"](function () {
        if (_this7.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP) {
          var _this7$rootStore2, _this7$rootStore2$pla;

          try {
            var _this7$rootStore, _this7$rootStore$menu, _this7$rootStore$menu2;

            _this7 === null || _this7 === void 0 ? void 0 : (_this7$rootStore = _this7.rootStore) === null || _this7$rootStore === void 0 ? void 0 : (_this7$rootStore$menu = _this7$rootStore.menuList) === null || _this7$rootStore$menu === void 0 ? void 0 : (_this7$rootStore$menu2 = _this7$rootStore$menu.cartModel) === null || _this7$rootStore$menu2 === void 0 ? void 0 : _this7$rootStore$menu2.setCartData(null);
            _this7.rootStore.menuList.breadSticksModel.cartItems = null; // Once Order is placed remove orderID for store.

            _this7.rootStore.common.orderID = null;
          } catch (error) {}

          (_this7$rootStore2 = _this7.rootStore) === null || _this7$rootStore2 === void 0 ? void 0 : (_this7$rootStore2$pla = _this7$rootStore2.platformUtil) === null || _this7$rootStore2$pla === void 0 ? void 0 : _this7$rootStore2$pla.navigateToRoute("/order-ahead/confirmation/", [{
            name: "orderId",
            value: orderId
          }]);
          _this7.rootStore.refreshInProgress = false;
        } else {
          _this7.rootStore.platformUtil.redirectToURL("/order-ahead/confirmation?orderId=".concat(orderId));
        }
      });
    }
  }, {
    key: "setJoinEClub",
    value: function () {
      var _setJoinEClub = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(email, signupSource) {
        var secondarySubscriptions,
            res,
            _this$rootStore15,
            _this$rootStore15$app,
            _this$rootStore16,
            _this$rootStore16$app,
            _args19 = arguments;

        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                secondarySubscriptions = _args19.length > 2 && _args19[2] !== undefined ? _args19[2] : [];
                _context19.next = 3;
                return DPServices.Confirmation.setJoinEClub(email, signupSource, secondarySubscriptions);

              case 3:
                res = _context19.sent;

                if (res !== null && res !== void 0 && res.guestAlreadySubscribed) {
                  (_this$rootStore15 = this.rootStore) === null || _this$rootStore15 === void 0 ? void 0 : (_this$rootStore15$app = _this$rootStore15.appMessages) === null || _this$rootStore15$app === void 0 ? void 0 : _this$rootStore15$app.showError("Error", "You are already subscribed to the eClub.");
                } else {
                  // analytics code
                  this.analyticsModel.processEClubEvent(secondarySubscriptions, signupSource);
                  (_this$rootStore16 = this.rootStore) === null || _this$rootStore16 === void 0 ? void 0 : (_this$rootStore16$app = _this$rootStore16.appMessages) === null || _this$rootStore16$app === void 0 ? void 0 : _this$rootStore16$app.showError("Success", "You have been subscribed to the eClub.");
                }

                return _context19.abrupt("return", res);

              case 6:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function setJoinEClub(_x13, _x14) {
        return _setJoinEClub.apply(this, arguments);
      }

      return setJoinEClub;
    }()
  }, {
    key: "createAccount",
    value: function () {
      var _createAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(args) {
        var res, _args$dobYear, _this$_sessionDetails3, _this$_sessionDetails4, _this$_sessionDetails5, _this$_sessionDetails6, _this$rootStore$platf, _this$rootStore17, _this$rootStore17$app, _res$data;

        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return DPServices.Confirmation.createAccount(args);

              case 2:
                res = _context20.sent;

                if (res.success) {
                  // analytics code
                  this.accountCreationEvent(null, null, "US", args === null || args === void 0 ? void 0 : (_args$dobYear = args.dobYear) === null || _args$dobYear === void 0 ? void 0 : _args$dobYear.toString(), this === null || this === void 0 ? void 0 : (_this$_sessionDetails3 = this._sessionDetails) === null || _this$_sessionDetails3 === void 0 ? void 0 : (_this$_sessionDetails4 = _this$_sessionDetails3.restaurantDetails) === null || _this$_sessionDetails4 === void 0 ? void 0 : _this$_sessionDetails4.restaurantId, this === null || this === void 0 ? void 0 : (_this$_sessionDetails5 = this._sessionDetails) === null || _this$_sessionDetails5 === void 0 ? void 0 : (_this$_sessionDetails6 = _this$_sessionDetails5.restaurantDetails) === null || _this$_sessionDetails6 === void 0 ? void 0 : _this$_sessionDetails6.restaurantNumber);
                  (_this$rootStore$platf = this.rootStore.platformUtil) === null || _this$rootStore$platf === void 0 ? void 0 : _this$rootStore$platf.redirectToURL("/customer-service/recent-activity");
                } else {
                  (_this$rootStore17 = this.rootStore) === null || _this$rootStore17 === void 0 ? void 0 : (_this$rootStore17$app = _this$rootStore17.appMessages) === null || _this$rootStore17$app === void 0 ? void 0 : _this$rootStore17$app.showError("Error", "A user already exists with the login ".concat(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.login));
                }

                return _context20.abrupt("return", res);

              case 5:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function createAccount(_x15) {
        return _createAccount.apply(this, arguments);
      }

      return createAccount;
    }()
  }, {
    key: "accountCreationEvent",
    value: function () {
      var _accountCreationEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(zipCode, state, country, birthYear, restId, restNum) {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                this.analyticsModel.dispatchOrderConfirmationAccCreat(zipCode, state, country, birthYear, restId, restNum);

              case 1:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function accountCreationEvent(_x16, _x17, _x18, _x19, _x20, _x21) {
        return _accountCreationEvent.apply(this, arguments);
      }

      return accountCreationEvent;
    }()
  }, {
    key: "cartItemTotalQuantity",
    value: function cartItemTotalQuantity(items) {
      var total = 0;
      items === null || items === void 0 ? void 0 : items.forEach(function (_c) {
        total = total + (_c === null || _c === void 0 ? void 0 : _c.quantity);
      });
      return total;
    }
  }, {
    key: "itemsForCartDetails",
    get: function get() {
      var _this$cartModel, _this$cartOrder;

      return (_this$cartModel = this.cartModel) === null || _this$cartModel === void 0 ? void 0 : _this$cartModel.getCartItemsFromCommerceItems((_this$cartOrder = this.cartOrder) === null || _this$cartOrder === void 0 ? void 0 : _this$cartOrder.commerceItems);
    }
  }, {
    key: "submitCount",
    get: function get() {
      return this._submitCount;
    }
  }, {
    key: "cartItemsCount",
    get: function get() {
      var _this$cartOrder2;

      return this.cartItemTotalQuantity((_this$cartOrder2 = this.cartOrder) === null || _this$cartOrder2 === void 0 ? void 0 : _this$cartOrder2.commerceItems);
    }
  }]);

  return DineInOrder;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "cartOrder", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_restuarantDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "checkoutAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_submitCount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, "submitOrder", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submitOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "itemsForCartDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "itemsForCartDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submitCount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "submitCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cartItemsCount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cartItemsCount"), _class.prototype)), _class);
export { DineInOrder as default };